import { render, staticRenderFns } from "./RegistrationJoinUserComponent.vue?vue&type=template&id=19d82dde&scoped=true"
import script from "./RegistrationJoinUserComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationJoinUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d82dde",
  null
  
)

export default component.exports